'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');

const BindFunctions = [
    'onShow',
    'onInActive',
    'onActive'
];

module.exports = Base.extend({

    events: {},

    initialize: function () {
        Base.prototype.initialize.call(this);
        _.bindAll(this, BindFunctions);
    },

    onShow: function () {

    },

    onInActive: function () {

    },

    onActive: function () {

    }

});
